import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

const FILTERS = [
  { key: "all", label: "Все" },
  { key: "paid", label: "Оплатили" },
  { key: "unpaid", label: "Не оплатили" },
];

export default function MfcClientsPage() {
  const [clients, setClients] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/mfc-clients").then(r => {
      setClients(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filtered = clients.filter(c => {
    if (filter === "paid") return c.paid;
    if (filter === "unpaid") return !c.paid;
    return true;
  });

  if (loading) return <div style={{ padding: 32, color: "#8fa0b4" }}>Загрузка...</div>;

  return (
    <div style={{ padding: "24px 32px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1e2a3a", margin: 0 }}>МФЦ-сервис — клиенты</h1>
        <span style={{ fontSize: 13, color: "#8fa0b4" }}>{filtered.length} чел.</span>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {FILTERS.map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)} style={{
            padding: "6px 14px", borderRadius: 6, border: "none", cursor: "pointer",
            fontSize: 13, fontWeight: filter === f.key ? 600 : 400,
            background: filter === f.key ? "#4f6ef7" : "#f1f5f9",
            color: filter === f.key ? "#fff" : "#4a5568",
          }}>{f.label}</button>
        ))}
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: "2px solid #e2e8f0", textAlign: "left" }}>
              <th style={thStyle}>Имя</th>
              <th style={thStyle}>Телефон</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Оплата</th>
              <th style={thStyle}>Этап</th>
              <th style={thStyle}>Чат</th>
              <th style={thStyle}>Договор</th>
              <th style={thStyle}>Регистрация</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(c => (
              <tr key={c.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={tdStyle}><span onClick={() => navigate(`/mfc-service/${c.id}`)} style={{ color: "#4f6ef7", cursor: "pointer", fontWeight: 500 }}>{c.fssp_form ? `${c.fssp_form.lastName} ${c.fssp_form.firstName} ${c.fssp_form.patronymic || ""}`.trim() : (c.name || "—")}</span></td>
                <td style={tdStyle}>{c.phone ? <a href={"tel:" + c.phone} style={{ color: "#4f6ef7", textDecoration: "none" }}>{c.phone}</a> : "—"}</td>
                <td style={tdStyle}>{c.email || "—"}</td>
                <td style={tdStyle}>{c.paid ? <span style={badgePaid}>Да</span> : <span style={badgeUnpaid}>Нет</span>}</td>
                <td style={tdStyle}><StageBadge done={c.steps_done} last={c.last_stage} /></td>
                <td style={tdStyle}>
                  <button onClick={() => navigate(`/mfc-service/${c.id}/chat`)} style={chatBtn}>
                    💬 {c.unread > 0 && <span style={unreadBadge}>{c.unread}</span>}
                  </button>
                </td>
                <td style={tdStyle}>
                  <button onClick={() => navigate(`/mfc-service/${c.id}/contract`)} style={contractBtn}>
                    {contractLabel(c.contract_status)}
                  </button>
                </td>
                <td style={tdStyle}>{formatDate(c.created_at)}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={8} style={{ padding: 24, textAlign: "center", color: "#8fa0b4" }}>Нет клиентов</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function StageBadge({ done, last }) {
  const steps = done || 0;
  const bg = steps >= 12 ? "#dcfce7" : steps > 0 ? "#fef9c3" : "#f1f5f9";
  const color = steps >= 12 ? "#166534" : steps > 0 ? "#854d0e" : "#64748b";
  return <span style={{ padding: "3px 10px", borderRadius: 10, fontSize: 12, fontWeight: 600, background: bg, color }}>{steps}/12</span>;
}

function formatDate(d) {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
}

function contractLabel(s) {
  if (!s) return "—";
  if (s === "pending") return "⏳ Ожидает";
  if (s === "active") return "✅ Активен";
  if (s === "completed") return "✔ Завершён";
  if (s === "cancelled") return "❌ Отменён";
  return s;
}

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.03em" };
const tdStyle = { padding: "10px 12px" };
const badgePaid = { padding: "3px 10px", borderRadius: 10, fontSize: 12, fontWeight: 600, background: "#dcfce7", color: "#166534" };
const badgeUnpaid = { padding: "3px 10px", borderRadius: 10, fontSize: 12, fontWeight: 600, background: "#fee2e2", color: "#991b1b" };
const chatBtn = { background: "none", border: "1px solid #e2e8f0", borderRadius: 8, padding: "4px 10px", cursor: "pointer", fontSize: 14, position: "relative", display: "inline-flex", alignItems: "center", gap: 4 };
const contractBtn = { background: "none", border: "1px solid #e2e8f0", borderRadius: 8, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 };
const unreadBadge = { background: "#ef4444", color: "#fff", fontSize: 10, fontWeight: 700, borderRadius: "50%", width: 18, height: 18, display: "inline-flex", alignItems: "center", justifyContent: "center" };
